import { Schema } from "@effect/schema";
import { Address, GraphAddress } from "@silo/types";
import { Effect, pipe } from "effect";
import { request } from "./request";
import { UserMarketAddresses } from "../types";
import { satisfies } from "effect/Function";

export type GetUserMarketAddresses = ReturnType<typeof getUserMarketAddresses>;
export type GetUserMarketAddressesSuccess =
  Effect.Effect.Success<GetUserMarketAddresses>;
export type GetUserMarketAddressesError =
  Effect.Effect.Error<GetUserMarketAddresses>;
export type GetUserMarketAddressesContext =
  Effect.Effect.Context<GetUserMarketAddresses>;

export function getUserMarketAddresses(user: Address) {
  return Effect.gen(function* () {
    const variables = yield* pipe(
      user,
      Schema.encode(GraphAddress),
      Effect.map((user) => ({ account: user }))
    );

    const { siloPositions } = yield* request({
      query,
      variables,
      schema: UserMarketAddressesResponse,
    });

    const marketAddresses = siloPositions.map(({ silo }) => silo.id);

    const userMarketAddresses = satisfies<UserMarketAddresses>()({
      source: "graph",
      marketAddresses,
    } as const);

    return userMarketAddresses;
  });
}

const query = `#graphql
  query UserMarketAddresses($account: String) {
    siloPositions(where: { account: $account, isActive: true }) {
      silo {
        id
      }
    }
  }
`;

export type UserMarketAddressesResponse =
  typeof UserMarketAddressesResponse.Type;
export type UserMarketAddressesResponseEncoded =
  typeof UserMarketAddressesResponse.Encoded;

export const UserMarketAddressesResponse = Schema.Struct({
  siloPositions: Schema.Array(
    Schema.Struct({
      silo: Schema.Struct({ id: GraphAddress }),
    })
  ),
}).annotations({ identifier: "UserMarketAddressesResponse" });
